import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

export interface InfoTooltipProps {
  /** Help text shown in the tooltip (for novice users) */
  text: string;
  /** Optional id for the tooltip (for accessibility when multiple on page) */
  id?: string;
  /** Placement of tooltip */
  placement?: "top" | "bottom" | "left" | "right";
}

/**
 * Small info icon with tooltip. Use next to labels or field names to explain
 * what a field is for – especially helpful for new users.
 */
const InfoTooltip: React.FC<InfoTooltipProps> = ({
  text,
  id,
  placement = "top",
}) => {
  const tooltipId = id ?? `info-tooltip-${Math.random().toString(36).slice(2, 9)}`;
  return (
    <OverlayTrigger
      placement={placement}
      overlay={<Tooltip id={tooltipId}>{text}</Tooltip>}
      children={
        <span
          className="text-muted ms-1 ntcog-info-tooltip-trigger"
          role="img"
          aria-label={text}
          style={{ cursor: "help", verticalAlign: "middle" }}
        >
          <i className="bi bi-info-circle" style={{ fontSize: "0.95rem" }} />
        </span>
      }
    />
  );
};

export default InfoTooltip;
